














import Vue, { PropOptions } from 'vue'; // eslint-disable-line

export default Vue.extend({
  name: 'selectBoxSimple',
  props: {
    name: String,
    initialValue: Number,
    options: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectValue: {} as Number | String,
    };
  },
  watch: {
    selectValue() {
      this.$emit('change', this.selectValue);
    },
    initialValue() {
      this.selectValue = this.initialValue;
    },
  },
});
